const filterSelectByLabel = (userText, option) => {
  const query = (userText || '').trim().toLowerCase();
  if (!query) {
    return true;
  }
  const label = option && option.props && option.props.children;
  if (typeof label !== 'string') {
    return false;
  }
  return label.toLowerCase().includes(query);
};

export {
  filterSelectByLabel,
};
